import { render, staticRenderFns } from "./RecommendCourseItem.vue?vue&type=template&id=ad22c8f6&scoped=true&"
import script from "./RecommendCourseItem.vue?vue&type=script&lang=js&"
export * from "./RecommendCourseItem.vue?vue&type=script&lang=js&"
import style0 from "./RecommendCourseItem.vue?vue&type=style&index=0&id=ad22c8f6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad22c8f6",
  null
  
)

export default component.exports